<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Session Name" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <!-- <label for="inputName">Status</label> -->
                <!-- <input type="text" readonly class="form-control" id="inputStatus" v-model="formData.status"> -->
                <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ORDERS }"><a @click="onClickTabOrders()" href="#tab_2" data-toggle="tab" aria-expanded="true">Orders</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_PAYMENT }"><a @click="onClickTabPayment()" href="#tab_3" data-toggle="tab" aria-expanded="true">Summary of Payment</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputOpeningBalance" class="col-sm-4 control-label">Opening Balance</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputOpeningBalance" placeholder="" v-model="formData.openingBalance">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProject" class="col-sm-4 control-label">Project</label>
                              <div class="col-sm-8">
                                <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTransactionBalance" class="col-sm-4 control-label">Transaction Balance</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTransactionBalance" placeholder="" v-model="formData.transactionBalance">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCashier" class="col-sm-4 control-label">Cashier</label>
                              <div class="col-sm-8">
                                <select v-model="formData.cashierId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listCashier" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputClosingBalance" class="col-sm-4 control-label">Closing Balance</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputClosingBalance" placeholder="" v-model="formData.closingBalance">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPOS" class="col-sm-4 control-label">Point of Sales</label>
                              <div class="col-md-8">
                                <select v-model="formData.pointOfSalesId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listPOS" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputDifferent" class="col-sm-4 control-label">Different</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputDifferent" placeholder="" v-model="formData.different">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputLocation" class="col-sm-4 control-label">Location</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputLocation" placeholder="" v-model="formData.locationId">
                              </div>                     
                            </div>
                          </div>
                        </div>                            
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ORDERS }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                            <label for="recordPerPageOrder" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                            <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                              <select @change="changePageSizeOrder($event)" ref="recordPerPageOrder" class="form-control">
                                <option v-if="inquiryOrderParam.pageSize == 5" selected>5</option><option v-else>5</option>
                                <option v-if="inquiryOrderParam.pageSize == 10" selected>10</option><option v-else>10</option>
                                <option v-if="inquiryOrderParam.pageSize == 20" selected>20</option><option v-else>20</option>
                                <option v-if="inquiryOrderParam.pageSize == 50" selected>50</option><option v-else>50</option>
                                <option v-if="inquiryOrderParam.pageSize == 100" selected>100</option><option v-else>100</option>
                              </select>
                            </div>          
                            <div class="box-tools">              
                              <button v-on:click="inquiryOrder" class="btn btn-warning">Search</button>
                            </div>
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="width:85px;text-align:center;">Action</th>
                                <th style="text-align:left;">Name</th>
                                <th style="text-align:center;">Document Date</th>
                                <th style="text-align:left;">Customer</th>
                                <th style="text-align:left;">Project</th>
                                <th style="text-align:right;">Amount</th>
                                <th style="text-align:right;">Tax</th>
                                <th style="text-align:right;">Net Amount</th>
                                <th style="text-align:right;">Paid Amount</th>
                                <th style="text-align:right;">Return Amount</th>
                                <th style="text-align:center;">Currency</th>
                                <th style="text-align:center;">Status</th>
                                <th style="text-align:right;">No of Print</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listOrder" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceOrder + i + 1}}</td>
                                <td style="width:85px;text-align:center;">
                                  <a href="#" v-on:click="onDisplayOrder(row)" ref="displayRow" style="padding-right:5px">
                                    <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display Order"></span>
                                  </a>
                                  <a v-if="formData.status === STATUS_INPROGRESS && row.status === STATUS_ORDER_PAID" href="#" v-on:click="onVoidOrder(row)" ref="displayRow" style="padding-right:5px">
                                    <span class="icon ion-close" data-toggle="tooltip" data-placement="right" title="Void Order"></span>
                                  </a>                                  
                                </td>                                
                                <td style="text-align:left;" nowrap>{{ row.name }}</td>
                                <td style="text-align:center;" nowrap>{{ row.documentDate }}</td>
                                <td style="text-align:left;" nowrap>{{ row.customerName }}</td>
                                <td style="text-align:left;" nowrap>{{ row.projectName }}</td>
                                <td style="text-align:right;">{{ row.totalAmount }}</td>
                                <td style="text-align:right;">{{ row.taxAmount }}</td>
                                <td style="text-align:right;">{{ row.totalAmountIncludeTax }}</td>
                                <td style="text-align:right;">{{ row.paidAmount }}</td>
                                <td style="text-align:right;">{{ row.returnAmount }}</td>
                                <td style="text-align:center;">{{ row.currencyName }}</td>
                                <td style="text-align:center;">{{ row.status }}</td>
                                <td style="text-align:right;">{{ row.noOfPrint }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.projectId }}</td>
                                <td hidden>{{ row.customerId }}</td>
                                <td hidden>{{ row.billId }}</td>
                                <td hidden>{{ row.currencyId }}</td>
                                <td hidden>{{ row.sessionId }}</td>
                                <td hidden>{{ row.pointOfSalesId }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                          <div class="form-group">
                            <label style="width:25px;text-align:right;">
                                <a href="#"><i @click="changePageOrder(1)" class="icon ion-ios-rewind"></i></a>
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePageOrder(inquiryOrderParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                            </label>
                            <label>
                                Page
                            </label>
                            <label>
                                <input v-model="inquiryOrderParam.CurrentPageNumber" v-on:keyup.enter="gotoPageOrder($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                            </label>
                            <label id="TotalPageText">
                              {{ totalPagesOrder }}                
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePageOrder(inquiryOrderParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                            </label>
                            <label style="width:25px;text-align:left;">
                                <a href="#"><i @click="changePageOrder(totalPagesOrder)" class="icon ion-ios-fastforward"></i></a>
                            </label>
                          </div>
                        </div>                        
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_PAYMENT }" class="tab-pane" id="tab_3">
                      <div class="box no-border">                             
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:10px;text-align:right">#</th>
                                <th style="text-align:left;">Payment Method</th>
                                <th style="text-align:right;">Total Amount</th>
                                <th style="text-align:center;">Currency</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listPayment" v-bind:key="i">
                                <td style="text-align:right;">{{ startSequencePayment + i + 1}}</td>
                                <td style="text-align:center;">{{ row.paymentMethodName }}</td>
                                <td style="text-align:right;">{{ row.amount }}</td>
                                <td style="text-align:center;">{{ row.currencyName }}</td>
                                <td hidden>{{ row.paymentMethodId }}</td>
                                <td hidden>{{ row.currencyId }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>                        
                    </div>                    
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" id="inputId" v-model="formData.id">
              <input type="hidden" class="form-control" id="inputProductTypeId" v-model="formData.projectId">
              <input type="hidden" class="form-control" id="inputProductCategoryId" v-model="formData.cashierId">
              <input type="hidden" class="form-control" id="inputProjectId" v-model="formData.pointOfSalesId">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <button v-if="formData.status === STATUS_CLOSED" @click="onPosting()" class="btn btn-primary pull-right" style="margin-right:15px;">Validate and Post</button>
                <button v-if="formData.status === STATUS_INPROGRESS" class="btn btn-primary pull-right" style="margin-right:15px;" data-toggle="modal" data-target="#modal-closing">Closing</button>                                
                <!-- <button @click="onCancel()" class="btn btn-warning">Cancel</button> -->
                <!-- <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button> -->
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>

    <div class="modal fade" id="modal-closing" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">POS Closing</h4>
          </div>
          <div class="modal-body">
            <div class="box no-border form-horizontal">
              <div class="form-group">
                <label class="col-sm-4 control-label">Opening Balance</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputOpeningBalanceModal" v-model="formData.openingBalance">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Transaction Balance</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputTransactionBalanceModal" v-model="formData.transactionBalance">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Closing Balance</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputClosingBalanceModal" v-model="formData.closingBalance" ref="closingBalance">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Actual Closing Balance</label>
                <div class="col-md-8">
                  <input @keyup="formattingNumber($event)" type="text" class="form-control" v-model="formData.actualClosingBalance" id="actualClosingBalance" ref="actualClosingBalance">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-sm-4 control-label">Others Fee</label>
                <div class="col-md-8">
                  <input @keyup="formattingNumber($event)" type="text" class="form-control" v-model="formData.otherFee" id="otherFee" ref="otherFee">
                </div>                     
              </div>                            
              <div class="form-group">
                <label class="col-sm-4 control-label">Different</label>
                <div class="col-md-8">
                  <input type="text" readonly class="form-control" id="inputDifferentModal" v-model="formData.different" ref="different">
                </div>                     
              </div>                                                       
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" @click="onContinueClosing($event)">Continue</button>
          </div>
        </div>
      </div>
    </div>    
  </div>  
</template>

<script>
import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'
import utilities from '../../utilities'
import axios from 'axios'

const MODE_NONE = 'none'
// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_ORDERS = 'tabOrders'
const TAB_PAYMENT = 'tabPayment'
const STATUS_INPROGRESS = 'InProgress'
const STATUS_CLOSED = 'Closed'
const STATUS_POSTED = 'Posted'
const STATUS_ORDER_PAID = 'Paid'
const STATUS_ORDER_VOID = 'Void'
const STATUS_ORDER_RETURN = 'Return'

export default {
  name: 'POSSessionForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_ORDERS: TAB_ORDERS,
      TAB_PAYMENT: TAB_PAYMENT,
      STATUS_INPROGRESS: STATUS_INPROGRESS,
      STATUS_CLOSED: STATUS_CLOSED,
      STATUS_POSTED: STATUS_POSTED,
      STATUS_ORDER_PAID: STATUS_ORDER_PAID,
      STATUS_ORDER_VOID: STATUS_ORDER_VOID,
      STATUS_ORDER_RETURN: STATUS_ORDER_RETURN,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        projectId: 0,
        cashierId: 0,
        openingDate: '',
        closingDate: '',
        status: '',
        openingBalance: 0,
        transactionBalance: 0,
        closingBalance: 0,
        actualClosingBalance: 0,
        otherFee: 0,
        different: 0,
        locationId: '',
        pointOfSalesId: 0,
        orderSeqNo: 0,
        loginSeqNo: 0
      },
      listOrder: null,
      totalRowsOrder: 0,
      totalPagesOrder: 0,
      startSequenceOrder: 0,
      inquiryOrderParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'CreatedDate'
      },
      startSequencePayment: 0,
      tabActive: '',
      listProject: null,
      listCashier: null,
      listPOS: null,
      showValidFrom: false,
      listPayment: null
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.callbackId ? this.$route.params.callbackId : this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback

    this.tabActive = TAB_GENERAL
    this.getDetail()
  },
  mounted() {
    this.$refs.recordPerPageOrder.value = this.inquiryOrderParam.PageSize
  },
  methods: {
    getDetail() {
      api
        .request('POS', 'get', '/api/Session/GetDetail?Id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity

          this.formData.closingBalance = utilities.DisplayNumber(utilities.ParseNumber(this.formData.openingBalance) + utilities.ParseNumber(this.formData.transactionBalance))
          this.formData.different = this.formData.closingBalance
        })
        .then(response => {
          this.getProject()
          this.getCashier()
          this.getPointOfSales()
          this.getCurrency()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrency() {
      api
        .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProject() {
      api
        .request('Account', 'get', '/api/Project/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listProject = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCashier() {
      api
        .request('Account', 'get', '/api/Account/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listCashier = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPointOfSales() {
      api
        .request('POS', 'get', '/api/POS/InquiryAll', null)
        .then(response => {
          var data = response.data
          this.listPOS = data.entity
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      this.$router.push({ name: this.callback })
    },
    // set closing balance and different amount and status is 'Closing Control'
    onContinueClosing() {
      let different = utilities.ParseNumber(this.formData.different)
      if (different !== 0) {
        SweetAlert.fire('Closing process', 'You have different closing amount. Please check again. ', 'error')
        return
      }
      var reqData = {
        id: this.formData.id,
        actualClosingBalance: this.$refs.actualClosingBalance.value,
        otherFee: this.$refs.otherFee.value
      }

      var status = ''
      var message = ''
      api
        .request('POS', 'post', '/api/Session/Closing', reqData)
        .then(response => {
          status = response.data.returnStatus ? 'success' : 'error'
          message = response.data.returnMessage.join('<br>')
          SweetAlert.fire('Closing process', message, status)
        })
        .then(response => {
          if (status === 'success') {
            this.$refs.btnCloseModal.click()
            this.getDetail()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    // Create SO and set status as 'Posted'
    onPosting() {
      var reqData = {
        id: this.formData.id
      }

      var status = ''
      var message = ''
      api
        .request('POS', 'post', '/api/Session/Post', reqData)
        .then(response => {
          status = response.data.returnStatus ? 'success' : 'error'
          message = response.data.returnMessage.join('<br>')
          SweetAlert.fire('Posting process...', message, status)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabOrders() {
      this.inquiryOrder()
    },
    inquiryOrder() {
      const requestProject = api.request('Account', 'get', '/api/Project/Inquiry?WhereClause=&CurrentPageNumber=1&PageSize=999', null)
      const requestOrder =
        api
          .request('POS', 'get', '/api/Order/Inquiry?WhereClause=SessionId = ' + this.formData.id +
                                  '&PageSize=' + this.inquiryOrderParam.PageSize + '&CurrentPageNumber=' + this.inquiryOrderParam.CurrentPageNumber +
                                  '&SortDirection=' + this.inquiryOrderParam.SortDirection + '&SortExpression=' + this.inquiryOrderParam.SortExpression, null)
      axios
        .all([requestProject, requestOrder])
        .then(
          axios.spread((...response) => {
            const responseProject = response[0]
            const responseOrder = response[1]

            this.listOrder = responseOrder.data.entity
            this.totalRowsOrder = responseOrder.data.totalRows
            this.totalPagesOrder = responseOrder.data.totalPages
            this.$refs.recordPerPageOrder.value = this.inquiryOrderParam.PageSize

            let currencyName = ''
            let projectName = ''
            this.listOrder.forEach(itemOrder => {
              this.listCurrency.some(function(itemCurrency, index) {
                if (itemOrder.currencyId === itemCurrency.id) {
                  currencyName = itemCurrency.name
                }
              })
              itemOrder.currencyName = currencyName

              responseProject.data.entity.some(function(itemProject, index) {
                if (itemOrder.projectId === itemProject.id) {
                  projectName = itemProject.name
                }
              })
              itemOrder.projectName = projectName
            })

            // Populate Customer
            var arrCustomer = []
            this.listOrder.forEach(itemOrder => {
              arrCustomer.push(itemOrder.customerId)
              var arrCustomerUnique = arrCustomer.filter(function(item, index) {
                return arrCustomer.indexOf(item) >= index
              })
              arrCustomer = arrCustomerUnique
            })

            this.getCustomerName(arrCustomer)
          })
        )
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    changePageSizeOrder(evt) {
      this.inquiryOrderParam.PageSize = evt.target.value
      this.inquiryOrderParam.CurrentPageNumber = 1
      this.startSequenceOrder = (this.inquiryOrderParam.CurrentPageNumber - 1) * this.inquiryOrderParam.PageSize
      this.inquiryOrder()
    },
    gotoPageOrder(evt) {
      if (evt.target.value > this.totalPagesOrder) {
        this.inquiryOrderParam.CurrentPageNumber = this.totalPagesOrder
      } else if (evt.target.value < 1) {
        this.inquiryOrderParam.CurrentPageNumber = 1
      }
      this.startSequenceOrder = (this.inquiryOrderParam.CurrentPageNumber - 1) * this.inquiryOrderParam.PageSize
      this.inquiryOrder()
    },
    changePageOrder(page) {
      if (page < 1) {
        this.inquiryOrderParam.CurrentPageNumber = 1
      } else if (page > this.totalPagesOrder) {
        this.inquiryOrderParam.CurrentPageNumber = this.totalPagesOrder
      } else {
        this.inquiryOrderParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryOrderParam.CurrentPageNumber - 1) * this.inquiryOrderParam.PageSize
      this.inquiryOrder()
    },
    getCustomerName(arrCustomer) {
      let whereClause = 'id in (' + arrCustomer.join(',') + ')'
      api
        .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCustomer.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          var listCustomer = data.entity

          var customerName
          this.listOrder.forEach(itemOrder => {
            customerName = ''
            listCustomer.some(function(item, index) {
              if (itemOrder.customerId === item.id) {
                customerName = (item.firstName + ' ' + item.lastName).trim()
              }
            })
            itemOrder.customerName = customerName
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabPayment() {
      this.inquiryPaymentSummary()
    },
    inquiryPaymentSummary() {
      api
        .request('POS', 'get', '/api/CashFlow/InquirySummaryBySession?SessionId=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listPayment = data.entity

          var currencyName
          this.listPayment.forEach(itemPayment => {
            currencyName = ''
            this.listCurrency.some(function(itemCurrency, index) {
              if (itemPayment.currencyId === itemCurrency.id) {
                currencyName = itemCurrency.name
              }
            })
            itemPayment.currencyName = currencyName
          })
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    formattingNumber(evt) {
      // When the arrow keys are pressed, etc..., abort.
      if ($.inArray(evt.keyCode, [9, 38, 40, 37, 39]) !== -1) {
        return
      }

      var input = this.$refs[evt.target.id].value
      var inputNumber = utilities.ParseNumber(input)
      this.$refs[evt.target.id].value = utilities.DisplayNumber(inputNumber)
      switch (evt.target.id) {
        case 'actualClosingBalance':
          this.formData.actualClosingBalance = utilities.DisplayNumber(inputNumber)
          this.calculateDifferent()
          break
        case 'otherFee':
          this.formData.otherFee = utilities.DisplayNumber(inputNumber)
          this.calculateDifferent()
          break
        default:
          break
      }
    },
    calculateDifferent() {
      this.formData.different = utilities.DisplayNumber(utilities.ParseNumber(this.formData.closingBalance) - utilities.ParseNumber(this.formData.actualClosingBalance) - utilities.ParseNumber(this.formData.otherFee))
    },
    onDisplayOrder(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name,
        callbackId: this.formData.id,
        originalcallback: this.callback
      }
      this.$router.push({ name: 'POS Order', params: params })
    },
    onVoidOrder(row) {
      let status = ''
      let message = ''
      let params = {
        Id: row.id,
        SessionId: row.sessionId
      }
      api
        .request('POS', 'post', '/api/Order/Void', params)
        .then(response => {
          status = response.data.returnStatus ? 'success' : 'error'
          message = response.data.returnMessage.join('<br>')
          SweetAlert.fire('Void Order', message, status)
        })
        .then(response => {
          this.getDetail()
          this.onClickTabOrders()
        })
        .catch(error => {
          message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// POSSessionForm.vue?d40c9a24